var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LegalAgreements',{attrs:{"title":_vm.$t('labels.imprint') + ' & ' + _vm.$t('labels.privacypolicy'),"get-url":"/admin/agreement/privacy-policy","post-url":"/admin/agreement/privacy-policy"}})}
var staticRenderFns = []

export { render, staticRenderFns }